import { FC } from "react";
import { SortOrder } from "../../../../store/superadmin/referral/types";
import { PendingVacancySortField } from "../../../../store/vacancy/types";
import Sort from "../../../UI/Icons/Sort";

export interface IPendingTableHeaderProps {
  sortBy: PendingVacancySortField;
  sortOrder: SortOrder;
  onSortChange: (field: PendingVacancySortField) => void;
}

const PendingTableHeader: FC<IPendingTableHeaderProps> = ({
  sortBy,
  sortOrder,
  onSortChange,
}) => {
  return (
    <div className="bg-white py-10px px-15px d-none d-lg-flex flex-column flex-lg-row gap-10 align-items-start align-items-lg-center justify-content-between border-bottom border-off-white fs-13 fw-400 text-black">
      <div className="flex-grow-1"></div>
      <div className="min-w-380px">
        <div
          className="fs-13 fw-700 d-flex gap-5 align-items-center cursor-pointer"
          onClick={() => onSortChange("timeframe")}
        >
          Requested Timeframe
          <Sort active={sortBy === "timeframe"} direction={sortOrder} />
        </div>
      </div>
      <div
        className="min-w-120px d-flex gap-5 align-items-center cursor-pointer"
        onClick={() => onSortChange("created_at")}
      >
        <div className="fs-13 fw-700">Posted</div>
        <Sort active={sortBy === "created_at"} direction={sortOrder} />
      </div>
      <div className="min-w-155px">
        <div className="fs-13 fw-700">Settings</div>
      </div>
      <div className="min-w-165px"></div>
      <div className="min-w-24px"></div>
    </div>
  );
};

export default PendingTableHeader;
